import styles from './index.module.scss';

function Topbar() {
  return (
    <div className={styles.topbar}>
      <div className={styles.logo}>Sagebridge</div>
    </div>
  );
}

export default Topbar;
